import { defineModule } from '@/core/define';
import { overridable } from '@/core/template-engine';
import state from '@/core/state';
import { getMemberInfo } from '@/core/http/api';

const LOCKED_STATUSES = ['pending', 'approved'];

// Members whose KYC is pending or approved cannot open the KYC form again.
async function kycGuard(to, from, next) {
    if (!localStorage.getItem('gamingToken')) return next();
    let info = state.memberInfo;
    if (!Object.keys(info).length) {
        try {
            const res = await getMemberInfo();
            info = res.data?.data || {};
            if (res.data?.error_code === '0') state.memberInfo = info;
        } catch {
            return next();
        }
    }
    const status = info.check_kyc?.can_withdraw || '';
    next(LOCKED_STATUSES.includes(status) ? '/profile' : undefined);
}

export default defineModule({
    id: 'kyc',
    routes: [
        {
            path: '/kyc',
            name: 'kyc',
            meta: { requiresAuth: true },
            beforeEnter: kycGuard,
            component: overridable('KycPage', () => import(/* webpackChunkName: "kyc" */ './views/KycPage.vue'))
        }
    ]
});
